import { SupportedPublicLocale } from './types';

/**
 * Detects the user's preferred locale from browser settings.
 * Only supports English and French for public reports.
 * Defaults to English if French is not detected.
 */
export function detectPublicLocale(): SupportedPublicLocale {
  const languages = navigator.languages || [navigator.language];

  for (const lang of languages) {
    if (lang.toLowerCase().startsWith('fr')) {
      return 'fr';
    }
  }

  return 'en';
}
